/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
export enum CalendarView {
    Agenda = "agenda",
    Day = "day",
    Week = "week",
    Month = "month",
    Quarter = "quarter",
    Year = "Year",
}